import { createRouter, createWebHistory } from 'vue-router'

import Home from '../views/Home.vue'
import Profiles from '../views/Profiles.vue'
import CreateCustomer from '../views/CreateCustomer.vue'
import Customer from '../views/Customer.vue'
import Orders from '../views/Orders.vue'
import Admin from '../views/Admin.vue'
import Order from '../views/Order.vue'
import SearchResults from '../views/SearchResults.vue'
import AddCustomerType from '../views/AddCustomerType.vue'
import AddCustomerSubType from '../views/AddCustomerSubType.vue'
import CreateOrder from '../views/CreateOrder.vue'
import AssignCategory from '../views/AssignCategory.vue'
import CanceledOrderSuccess from '../views/CanceledOrderSuccess.vue'
import CanceledOrderError from '../views/CanceledOrderError.vue'
import ReCreateOrder from '../views/ReCreateOrder.vue'
import ConfirmOrder from '../views/ConfirmOrder.vue'
import VerifyCustomerContact from '../views/VerifyCustomerContact.vue'
import VerifyCustomerSizing from '../views/VerifyCustomerSizing.vue'
import LoggedOutPage from '../views/LoggedOutPage.vue'
import AuthenticationFailed from '../views/AuthenticationFailed.vue'


const routes = [
  {
    path: '/home',
    name: 'Home',
    alias: '/',
    component: Home,
    meta: {requiresAuth: true}
  },
  {
    path: '/profiles',
    name: 'Profiles',
    component: Profiles,
    meta: {requiresAuth: true}
  },
  {
    path: '/create-customer',
    name: 'Create Customer',
    component: CreateCustomer,
    meta: {requiresAuth: true}
  },
  {
    path: '/customer/:customer_id',
    name: 'Customer',
    component: Customer,
    meta: {requiresAuth: true}
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/add_new_type',
    name: 'AddCustomerType',
    component: AddCustomerType,
    meta: {requiresAuth: true}
  },
  {
    path: '/admin/add_new_sub_type',
    name: 'AddCustomerSubType',
    component: AddCustomerSubType,
    meta: {requiresAuth: true}
  },
  {
    path: '/order/:id',
    name: 'Order',
    component: Order,
    meta: {requiresAuth: true}
  },
  {
    path: '/search-results/:type/term/:term?',
    name: 'Search Results',
    component: SearchResults,
    meta: {requiresAuth: true}
  },
  {
    path: '/create-order/:userid',
    name: 'Create Order',
    component: CreateOrder,
    meta: {requiresAuth: true}
  },
  {
    path: '/recreate-order/:orderid',
    name: 'ReCreate Order',
    component: ReCreateOrder,
    meta: {requiresAuth: true}
  },
  {
    path: '/confirm-order/:orderid',
    name: 'Confirm Order',
    component: ConfirmOrder,
    meta: {requiresAuth: true}
  },
  {
    path: '/assign-category/:orderid',
    name: 'Assign Category',
    component: AssignCategory,
    meta: {requiresAuth: true}
  },
  {
    path: '/cancel-order-success/',
    name: 'Cancel order',
    component: CanceledOrderSuccess,
    meta: {requiresAuth: true}
  },
  {
    path: '/cancel-order-error/',
    component: CanceledOrderError,
    meta: {requiresAuth: true}
  },
  {
    path: '/verify-customer-info/:verification_token',
    name: 'Verify Customer Info',
    component: VerifyCustomerContact,
    meta: {requiresAuth: false}
  },
  {
    path: '/verify-customer-sizing/:verification_token',
    name: 'Verify Customer Sizing',
    component: VerifyCustomerSizing,
    meta: {requiresAuth: false}
  },
  {
    path: "/auth/callback",
    name: "Auth0 Callback",
    meta: {requiresAuth: false}
  },
  {
    path: "/auth/logged-out",
    name: "Auth0 LoggedOut",
    component: LoggedOutPage,
    meta: {requiresAuth: false}
  },
  {
    path: "/auth/failed",
    name: "Auth0 Failed",
    component: AuthenticationFailed,
    meta: {requiresAuth: false}
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      if (savedPosition && (to.fullPath == '/' || to.fullPath == '/home') && from.name == 'Customer') {
        let maxPosition = { ...savedPosition }
        let scrollHandled = false

        const onScrollReady = (event) => {
          const newPos = event.detail?.position
          if (newPos && newPos.top > maxPosition.top) {
            maxPosition = newPos
          }

          if (!scrollHandled) {
            scrollHandled = true
            requestAnimationFrame(() => {
              window.removeEventListener('scroll-ready', onScrollReady)
              window.dispatchEvent(new CustomEvent('scroll', {
                detail: { page: event.detail?.page, position: maxPosition }
              }))
              resolve(maxPosition)
            })
          }
        }

        window.addEventListener('scroll-ready', onScrollReady)
      } else {
        resolve({ top: 0 })
      }

      if (savedPosition && from.name == 'Customer' && (from.fullPath != '/' || from.fullPath != '/home') && to.fullPath == '/profiles') {
        window.addEventListener('profiles-scroll-ready', (event) => {
          window.dispatchEvent(new CustomEvent('profiles-scroll', {
            detail: { page: event.detail.page, position: savedPosition }
          }))
        })
      } else if (to.fullPath == '/profiles'){
        window.addEventListener('profiles-scroll-ready', (event) => {
          window.dispatchEvent(new CustomEvent('profiles-scroll', {
            detail: { page: event.detail.page, position: { top: 0 } }
          }))
        })
      }

      if (to.name == 'Home' || to.name == 'Orders' || to.name == 'Admin') {
        sessionStorage.removeItem('customerTableParams');
      }
    })
  }
})

export default router
